import React from 'react';
import { Button } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { userLoggedOut } from "../../features/currentUserSlice";
import { CsmText } from "../../library/components/mui/CsmText";
import { mainScreenLocations } from "../../app/mainScreens";
import { sonDurumTemizlendi } from "../../features/loadingMessageSlice";
import { useTranslation } from "react-i18next";
import TranslationHelper from '../../helpers/TranslationHelper';

export function LogoutPage() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const translate = TranslationHelper.TransFunc(t);

    useEffect(() => {
        dispatch(sonDurumTemizlendi());
        dispatch(userLoggedOut());
        navigate(mainScreenLocations.login);
    })

    dispatch(userLoggedOut());
    dispatch(sonDurumTemizlendi())

    return (
        <div>
            <CsmText>{translate("Sistemden çıkış yapılmıştır. Otomatik olarak girişi sayfasına yönlendirileceksiniz")}</CsmText>
            <CsmText>{translate("Eğer yönlendirme yapılmazsa, aşağıdaki link üzerinden giriş sayfasına ilerleyebilirsiniz")}</CsmText>
            <Button onClick={() => navigate(mainScreenLocations.login)}>{translate("Giriş")}</Button>
        </div>
    );
}